import { BarrelTypeMap, pitchTypeTagMap } from "../Components/Map"
import { sortByTag, diffVal, bSearchForPR, bSearchPRCalc } from "./Sort"
import { PREntries } from "../Components/Map"
/*
Preferred Structure = {
  pitcher:
  [veloAvg, veloMax, spinAvg, spinMax, movement={top, left}] 
  for each pitch -> [{
    Player: Pitcher
    {
      ...stat of each pitch type
    }
  }]

  batter: {
    Player: Batter
    Count: cumulated ball counts
    LA: average launch angle
    SwSp%: TBD
    EV MAX / AVG
    EV FB/LD / GD
    Distance AVG / MAX : TBD
    Hard # / % : TBD
    Swing%: swings / count
  }
}
*/

export const roundTo = (num, digit=0) => {
  let power = 10**digit
  return Math.round(num*power)/power
}
const parseNum = (num) => {
  if (num[0] !== undefined) {
    if (num.includes('.')) return parseFloat(num)
    return parseInt(num)
  }
  return num
}
export const concatClipId = (date, cid) => {
  const dashpos = date.indexOf('-')
  return date.slice(0, dashpos)+date.slice(dashpos+1)+cid
}
const parseDirection = (directon) => {
  let spoint = directon.indexOf(':')
  if (spoint === -1) return undefined
  let hour = parseInt(directon.slice(0, spoint))
  let min = parseInt(directon.slice(spoint+1))
  if (isNaN(hour) || isNaN(min)) return undefined
  return [hour, min]
}

const PR_NEEDED = ['EV Max', 'EV Avg', 'Hard%', 'SwSp%', 'Whiff%', 'O-Swing%', 'Contact%']

export const resolveSheetDataBatter = (record, stat, past) => {
  let pData = {
    teststat: [], teststatPR: [], teststatPR_Comp: []
  }
  let dataByPlayer = {}
  let evIdResult = {}
  let swingCID = {}
  let CIDBatterMap = {}

  for (const e of record) {
    if (dataByPlayer[e.Batter] === undefined) {
      let init = { count: 0, swing: 0,
        l_angle: 0, l_angle_count: 0, 
        ev_max: -1000, ev_sum: 0, ev_count: 0,
        ev_fl_sum: 0, ev_fl_count: 0, ev_gd_sum: 0, ev_gd_count: 0,
        hard_count: 0, swsp_count: 0, miss: 0, oswing: 0, contact: 0, ozone: 0,
        good_count: 0,
      }
      dataByPlayer[e.Batter] = init;
    }
  }
  for (const e of record) {
    let cid = concatClipId(e.Date, e.Clip_Id)
    dataByPlayer[e.Batter].count++
    if (e.PitchCall==='S' || e.PitchCall==='F' || e.PitchCall==='I') {
      dataByPlayer[e.Batter].swing++
      swingCID[cid] = e.PitchCall
    }
    if (e.PitchCall==='I') evIdResult[cid] = e.HitType
    if (e.PitchCall==='S') dataByPlayer[e.Batter].miss++
    if (e.PitchCall==='F' || e.PitchCall==='I') dataByPlayer[e.Batter].contact++
    CIDBatterMap[cid] = e.Batter
  }
  for (const e of stat) {
    let cid = concatClipId(e.Date, e.Clip_Id)
    if (CIDBatterMap[cid] === undefined) continue
    let exitSpeed = parseFloat(e.ExitSpeed), angle = parseFloat(e.Angle)
    //console.log(CIDBatterMap[cid], cid)
    if (e.Zone === 'OUT') dataByPlayer[CIDBatterMap[cid]].ozone++
    if (e.Zone === 'OUT' && swingCID[cid] !== undefined) dataByPlayer[CIDBatterMap[cid]].oswing++
    if (evIdResult[cid] === undefined) continue
    else {
      if (evIdResult[cid] === 'G') {
        dataByPlayer[CIDBatterMap[cid]].ev_gd_sum += exitSpeed
        dataByPlayer[CIDBatterMap[cid]].ev_gd_count++
      } else {
        dataByPlayer[CIDBatterMap[cid]].ev_fl_sum += exitSpeed
        dataByPlayer[CIDBatterMap[cid]].ev_fl_count++
      }
      dataByPlayer[CIDBatterMap[cid]].ev_sum += exitSpeed
      dataByPlayer[CIDBatterMap[cid]].ev_count++
      if (exitSpeed >= 95*1.61) dataByPlayer[CIDBatterMap[cid]].hard_count++
      if (exitSpeed >= 140) dataByPlayer[CIDBatterMap[cid]].good_count++
      if (e.ExitSpeed >= dataByPlayer[CIDBatterMap[cid]].ev_max) dataByPlayer[CIDBatterMap[cid]].ev_max = exitSpeed
      dataByPlayer[CIDBatterMap[cid]].l_angle += angle
      dataByPlayer[CIDBatterMap[cid]].l_angle_count++
      if (angle >= 8 && angle <= 32) dataByPlayer[CIDBatterMap[cid]].swsp_count++
    }
  }
  for (const e in dataByPlayer) {
    const player = dataByPlayer[e]
    let pack = {
      Player: e,
      Count: player.count,
      'LA(°)': player.l_angle_count===0? '-':`${Math.round(player.l_angle*100/player.l_angle_count)/100}°`,
      'EV Max': player.ev_max===-1000? '-':player.ev_max,
      'EV Avg': player.ev_count===0? '-':Math.round(player.ev_sum*100/player.ev_count)/100,
      'EV FB/LD': player.ev_fl_count===0? '-':Math.round(player.ev_fl_sum*100/player.ev_fl_count)/100,
      'EV GD': player.ev_gd_count===0? '-':Math.round(player.ev_gd_sum*100/player.ev_gd_count)/100,
      'Swing%': `${Math.round(player.swing*10000/player.count)/100}%`,
      'SwSp%': player.l_angle_count===0? '-':`${Math.round(player.swsp_count*10000/player.l_angle_count)/100}%`,
      'Hard#': player.ev_count===0? '-':player.hard_count,
      'Hard%': player.ev_count===0? '-':`${Math.round(player.hard_count*10000/player.ev_count)/100}%`,
      'Whiff%': player.swing===0? '-': `${Math.round(player.miss*10000/player.swing)/100}%`,
      'O-Swing%': player.ozone===0? '-': `${Math.round(player.oswing*10000/player.ozone)/100}%`,
      'Contact%': player.swing===0? '-': `${Math.round(player.contact*10000/player.swing)/100}%`,
      'TSGNB': player.good_count,
      //'DIST MAX': 0,
      //'DIST AVG': 0
    }
    pData.teststat.push(pack)
  }
  //TBD: teststatPR & teststatPR_Comp
  //For pr calculation
  let sortedForPR = {}
  let testStat = [...pData.teststat]
  for (const e of PR_NEEDED) {
    sortedForPR[e] = sortByTag(testStat, e, (['Whiff%', 'O-Swing%'].includes(e)? true:false))
  }
  let PRbyPlayer = {}
  for (const e in sortedForPR) {
    const population = sortedForPR[e].length
    let idx = 0
    let even = []
    for (const p of sortedForPR[e]) {
      if (PRbyPlayer[p.Player] === undefined) {
        PRbyPlayer[p.Player] = {}
      }
      if (idx === 0) {
        even.push(p.Player)
      } else {
        if (diffVal(sortedForPR, e, idx)) {
          even.push(p.Player)
        } else {
          let winover = population - idx
          for (const k of even) {
            PRbyPlayer[k][e] = Math.ceil((winover)*100/population)
          }
          even = [p.Player]
        }
      }
      idx++
    }
    for (const k of even) {
      PRbyPlayer[k][e] = 0
    }
  }
  for (const p in PRbyPlayer) {
    pData.teststatPR.push({
      Player: p,
      ...PRbyPlayer[p]
    })
  }
  //for teststatPR_Comp
  let rankByTitle = {}
  for (const e of PR_NEEDED) {
    let collect = []
    for (const p of past) {
      //console.log(p, PREntries[e])
      collect.push(parseFloat(p[PREntries[e]]))
    }
    if (e !== 'Whiff%' && e !== 'O-Swing%') collect.sort((a,b)=>(a>=b? -1:1))
    else collect.sort((a,b)=>(a<b? -1:1))
    rankByTitle[e] = collect
  }
  let scoreByPlayer = {}
  for (const p of testStat) {
    scoreByPlayer[p.Player] = {}
    for (const e of PR_NEEDED) {
      let winover = bSearchForPR(rankByTitle[e], p[e], (e==='Whiff%'||e==='O-Swing%'))
      scoreByPlayer[p.Player][e] = isNaN(winover)? '-':Math.ceil(winover*100/(past.length+1))     
    }
  }
  for (const p in scoreByPlayer) {
    pData.teststatPR_Comp.push({
      Player: p,
      ...scoreByPlayer[p]
    })
  }

  return pData
}

export const resolveSheetDataPitcher = (record, stat) => {
  //TODO: extra: handle unknown
  let pData = {
    veloAvg: [], veloMax: [], spinAvg: [], spinMax: [], movement: [] 
  }
  let dataByPlayer = {}
  for (const e of record) {
    if (dataByPlayer[e.Player] === undefined) {
      let pitchstat = {sumVelo: 0, sumSpin: 0, veloCount: 0, spinCount: 0, maxSpin: 0, maxVelo: 0, vmSum: 0, hmSum: 0}
      let init = {
        FB: {...pitchstat}, CB: {...pitchstat}, CH: {...pitchstat}, SL: {...pitchstat}, FT: {...pitchstat},
        SP: {...pitchstat}, CT: {...pitchstat}, KN: {...pitchstat}, UN: {...pitchstat}
      }
      dataByPlayer[e.Player] = init
    }
  }
  for (const e of record) {
    let velocity = parseFloat(e['R-Velo-rel']), spin = parseFloat(e['R-SPIN']), h = parseFloat(e['R-HBreak']), v = parseFloat(e['R-VBreak'])
    let pitchtag = e.TaggedPitchType
    if (dataByPlayer[e.Player][pitchtag] === undefined) pitchtag = 'UN'
    if (velocity > 0) {
      dataByPlayer[e.Player][pitchtag].sumVelo += velocity
      dataByPlayer[e.Player][pitchtag].veloCount++
      if (velocity > dataByPlayer[e.Player][pitchtag].maxVelo) dataByPlayer[e.Player][pitchtag].maxVelo = velocity
    }
    if (spin > 0) {
      dataByPlayer[e.Player][pitchtag].sumSpin += spin
      dataByPlayer[e.Player][pitchtag].spinCount++
      if (spin > dataByPlayer[e.Player][pitchtag].maxSpin) dataByPlayer[e.Player][pitchtag].maxSpin = spin
      dataByPlayer[e.Player][pitchtag].vmSum += v
      dataByPlayer[e.Player][pitchtag].hmSum += h
    }
    /*
    if (h !== 0 || v !== 0) {
      const ph = 50.7+(h/10)*15.1, pv = 49.3+(v/10)*(-15.1)
      const position = {top: `${v>0? Math.max(0, pv):Math.min(100, pv)}%`, left: `${h<0? Math.max(0, ph):Math.min(100, ph)}%`}
      pData.movement.push({
        name: e.Player, number: 0, score: 10, velocity: velocity, spin: spin, type: pitchTypeTagMap[pitchtag], position: position
      })
    }
    */
  }
  for (const p in dataByPlayer) {
    let vmax = {Player: p}, vavg = {Player: p}, smax = {Player: p}, savg = {Player: p}
    for (const e in dataByPlayer[p]) {
      vmax[pitchTypeTagMap[e]] = dataByPlayer[p][e].veloCount===0? '-':dataByPlayer[p][e].maxVelo
      smax[pitchTypeTagMap[e]] = dataByPlayer[p][e].spinCount===0? '-':dataByPlayer[p][e].maxSpin
      vavg[pitchTypeTagMap[e]] = dataByPlayer[p][e].veloCount===0? '-':Math.round(10*dataByPlayer[p][e].sumVelo/dataByPlayer[p][e].veloCount)/10
      savg[pitchTypeTagMap[e]] = dataByPlayer[p][e].spinCount===0? '-':Math.round(10*dataByPlayer[p][e].sumSpin/dataByPlayer[p][e].spinCount)/10
      let vmavg = dataByPlayer[p][e].spinCount===0? '-':Math.round(10*dataByPlayer[p][e].vmSum/dataByPlayer[p][e].spinCount)/10
      let hmavg = dataByPlayer[p][e].spinCount===0? '-':Math.round(10*dataByPlayer[p][e].hmSum/dataByPlayer[p][e].spinCount)/10
      if (vmavg !== '-') {
        let ph = 50.7+(hmavg/10)*15.1, pv = 49.3+(vmavg/10)*(-15.1)
        let position = {top: `${vmavg>0? Math.max(0, pv):Math.min(100, pv)}%`, left: `${hmavg<0? Math.max(0, ph):Math.min(100, ph)}%`}
        pData.movement.push({
          name: p, number: 0, score: 10, velocity: vavg[pitchTypeTagMap[e]], spin: savg[pitchTypeTagMap[e]], type: pitchTypeTagMap[e], position: position,
          vbreak: vmavg, hbreak: hmavg
        })
      }
    }
    pData.veloMax.push(vmax)
    pData.veloAvg.push(vavg)
    pData.spinMax.push(smax)
    pData.spinAvg.push(savg)
  }
  
  return pData
}

export const extractDataByPitcher = (record, stat) => {
  let pData = {
    pitcherList: [], dataByPitcher: {}
  }
  let rawPitcherData = {}
  let globalPitchData = {}
  let pitchByPitch = {}

  const isEmpty = (val) => (val===undefined || val[0]===undefined)
  
  const onBase = ['1B', '2B', '3B', 'HR', 'E']
  const notAB = ['SF', 'SH']
  const swingCall = ['S', 'F', 'I']
  const strike = ['S', 'F', 'I', 'C']
  for (const p of record) {
    if (rawPitcherData[p.Pitcher] === undefined) {
      let initPitcherData = {
        result: { PA: 0, AB: 0, '1B': 0, '2B': 0, '3B': 0, HR: 0, SO: 0, BB: 0, E: 0, HBP: 0},
        stat: {pitches: 0, swing: 0, miss: 0, zswing: 0, oswing: 0, zcontact: 0, zone: 0, ozone: 0, strike: 0},
        barrel: {weak: 0, top: 0, under: 0, solid: 0, barrel: 0, flareburner: 0},
        cumulated: {ev_sum: 0, ev_count: 0, la_sum: 0, la_count: 0, ev_max: 0},
        inplay_clip_ids: [], 
        pitchtypes: {},
      }
      
      rawPitcherData[p.Pitcher] = initPitcherData
      pData.pitcherList.push(p.Pitcher)
    }
    let player = p.Pitcher, type = p.TaggedPitchType
    if (p['Balls'] === '1' && p['Strikes'] === '1') {
      rawPitcherData[player].result.PA ++
    }
    if (rawPitcherData[player].pitchtypes[type] === undefined) {
      let initPitchTypeData = {
        v_count: 0, v_sum: 0, v_max: 0, s_count: 0, s_sum: 0, seff_sum: 0, s_max: 0, seff_c: 0,
        b_count: 0, v_break: 0, h_break: 0, count: 0, strike: 0, sdir_count: 0, sdir_h: 0, sdir_m: 0,
        gyro_sum: 0, gyro_count: 0, velos: {}  
      }
      rawPitcherData[player].pitchtypes[type] = initPitchTypeData
    }
    //
    //update result
    if (p.PitchCall === 'I') {
      if (onBase.includes(p.PlayResult)) {
        rawPitcherData[player].result[p.PlayResult]++
        rawPitcherData[player].result.AB++
      } else if (!notAB.includes(p.PlayResult)) {
        rawPitcherData[player].result.AB++
      }
      rawPitcherData[player].inplay_clip_ids.push(concatClipId(p['Date'], p['Clip_Id']))
    } else if (!isEmpty(p.KorBB)) {
      if (p.KorBB === 'K') {
        rawPitcherData[player].result.SO++
        rawPitcherData[player].result.AB++
      } else {
        if (p.KorBB === 'HBP') rawPitcherData[player].result.HBP++
        else rawPitcherData[player].result.BB++
      }
    }
    pitchByPitch[concatClipId(p['Date'], p['Clip_Id'])] = {player: p.Pitcher, call: p.PitchCall, tag: p.TaggedPitchType}
    //update stat
    rawPitcherData[player].stat.pitches++
    if (p.PitchCall !== 'C' && p.PitchCall !== 'B') rawPitcherData[player].stat.swing++
    if (p.PitchCall === 'S') rawPitcherData[player].stat.miss++
    if (p.PitchCall !== 'B') rawPitcherData[player].stat.strike++
    
    rawPitcherData[player].pitchtypes[type].count++
    if (strike.includes(p.PitchCall)) rawPitcherData[player].pitchtypes[type].strike++
    
  }

  for (const p of stat) {
    let clip_id = concatClipId(p['Date'],p['Clip_Id'])
    if (pitchByPitch[clip_id] === undefined) continue
    let player = pitchByPitch[clip_id].player, type = pitchByPitch[clip_id].tag, call = pitchByPitch[clip_id].call
    let velo = parseNum(p['Velo-rel'])
    if (globalPitchData[type] === undefined) globalPitchData[type] = {count: 0, speedSum: 0}
    //update cumulated
    if (velo > 0) {
      rawPitcherData[player].pitchtypes[type].v_count++
      rawPitcherData[player].pitchtypes[type].v_sum += velo
      if (velo > rawPitcherData[player].pitchtypes[type].v_max) {
        rawPitcherData[player].pitchtypes[type].v_max = velo
      }
      globalPitchData[type].count++
      globalPitchData[type].speedSum += velo
      if (rawPitcherData[player].pitchtypes[type].velos[Math.round(velo)] === undefined) {
        rawPitcherData[player].pitchtypes[type].velos[Math.round(velo)] = 0
      }
      rawPitcherData[player].pitchtypes[type].velos[Math.round(velo)]++
    } 
    if (swingCall.includes(call) && p.Zone === 'IN') rawPitcherData[player].stat.zswing++
    if (swingCall.includes(call) && p.Zone === 'OUT') rawPitcherData[player].stat.oswing++
    if ((call === 'I' || call === 'F') && p.Zone === 'IN') rawPitcherData[player].stat.zcontact++
    if (p.Zone === 'IN') rawPitcherData[player].stat.zone++
    if (p.Zone === 'OUT') rawPitcherData[player].stat.ozone++
    if (rawPitcherData[player].inplay_clip_ids.includes(clip_id)) {
      let ev = parseNum(p.ExitSpeed), la = parseNum(p.Angle)
      if (ev > 0) {
        rawPitcherData[player].cumulated.ev_sum += ev
        rawPitcherData[player].cumulated.ev_count++
        if (ev > rawPitcherData[player].cumulated.ev_max) {
          rawPitcherData[player].cumulated.ev_max = ev
        }
        rawPitcherData[player].cumulated.la_sum += la
        rawPitcherData[player].cumulated.la_count++
        rawPitcherData[player].barrel[BarrelTypeMap[p.Barrel]]++
      }
    }
  }

  //console.log('rpdt:',rawPitcherData)
  
  //Pack up & calaulated data
  for (const p in rawPitcherData) {
    let init = {
      overall: [], pitchTypes: rawPitcherData[p].pitchtypes,
    }
    
    //overall performance
    let tb1 = [], tb2 = []
    let res = rawPitcherData[p].result, st = rawPitcherData[p].stat, cum = rawPitcherData[p].cumulated, br = rawPitcherData[p].barrel
    let H = res['1B']+res['2B']+res['3B']+res['HR']
    tb1.push(res.PA); tb1.push(res.AB); tb1.push(H); tb1.push(res['1B']);
    tb1.push(res['2B']); tb1.push(res['3B']); tb1.push(res['HR']); tb1.push(res['SO']); tb1.push(res['BB']);
    let avg = res.AB > 0? Math.round(H*1000/res.AB)/1000:'-'
    let wOBA = Math.round(((0.72*res.BB)+(0.75*res.HBP)+(0.9*res['1B'])+(0.92*res.E)+(1.24*res['2B'])+(1.56*res['3B'])+(1.95*res.HR))*1000/(res.PA))/1000
    let ev = cum.ev_count===0? '-':roundTo(cum.ev_sum/cum.ev_count, 1)
    let maxev = cum.ev_count===0? '-':cum.ev_max
    let la = cum.la_count===0? '-':roundTo(cum.la_sum/cum.la_count, 1)
    let whiff = st.swing===0? '-':roundTo(st.miss/st.swing, 3)*100
    whiff = isNaN(whiff)? whiff:roundTo(whiff,1)
    tb1.push(avg); tb1.push(wOBA); tb1.push(ev); tb1.push(maxev);
    tb1.push(la); tb1.push(whiff)
    init.overall.push(tb1)
    let swingavg = st.pitches===0? '-':Math.round(st.swing*1000/st.pitches)/10
    let zswing = st.zone===0? '-':Math.round(st.zswing*1000/st.zone)/10, oswing = st.ozone===0? '-':Math.round(st.oswing*1000/st.ozone)/10
    let zcontact = st.zone===0? '-':Math.round(st.zcontact*1000/st.zone)/10
    tb2.push(swingavg); tb2.push(zswing); tb2.push(oswing); tb2.push(zcontact)
    tb2.push(br.weak); tb2.push(br.top); tb2.push(br.under); tb2.push(br.flareburner); tb2.push(br.solid); tb2.push(br.barrel);
    init.overall.push(tb2)   
    //TODO: tb2 -> The second table (swing%, zswing%, ...)
    init.pitchescount = st.pitches
    init.cumStrikeP = roundTo(st.strike*100/st.pitches)
    pData.dataByPitcher[p] = init
  }

  pData.global = globalPitchData

  //console.log('pdata:',pData)

  return pData
}

export const extractPitcherBullpenGraphData = (bpData) => {
  let pData = {playerList: [], dataByPitcher: {}}
  let globalSpeedAvg = {}
  let rawPitcherData = {}
  for (const p of bpData) {
    if (pData.dataByPitcher[p.Player] === undefined) {
      let initPitcherData = {
        speed: {}, spin: [], sDirection: {}, release: {coordinate: {}, trend: []}, movement: {coordinate: {}, v: [], h: []}
      }
      pData.playerList.push(p.Player)
      pData.dataByPitcher[p.Player] = initPitcherData
      rawPitcherData[p.Player] = {pitchtypes: {}}
    }
    //collect data for table
    let availableTags = Object.keys(pitchTypeTagMap)
    let player = p.Player, type = availableTags.includes(p.TaggedPitchType)? p.TaggedPitchType:'UN'
    if (rawPitcherData[p.Player].pitchtypes[type] === undefined) {
      let initPitchTypeData = {
        v_count: 0, v_sum: 0, v_max: 0, s_count: 0, s_sum: 0, seff_sum: 0, s_max: 0, seff_c: 0,
        b_count: 0, v_break: 0, h_break: 0, count: 0, strike: 0, sdir_count: 0, sdir_h: 0, sdir_m: 0,
        gyro_sum: 0, gyro_count: 0  
      }
      rawPitcherData[p.Player].pitchtypes[type] = initPitchTypeData
    }
    let velo = parseNum(p['R-Velo-rel']), spin = parseNum(p['R-SPIN']), hb = parseNum(p['R-HBreak']), vb = parseNum(p['R-VBreak'])
    let relh = parseNum(p['R-ReleaseHeight']), rels = parseNum(p['R-ReleaseSide']), sdir = parseDirection(p['R-SpinDirection'])
    let seff = parseNum(p['R-SEFF']), gyro = parseNum(p['R-GYRO'])
    //collect table data
    if (velo > 0) {
      rawPitcherData[player].pitchtypes[type].v_count++
      rawPitcherData[player].pitchtypes[type].v_sum += velo
      if (velo > rawPitcherData[player].pitchtypes[type].v_max) {
        rawPitcherData[player].pitchtypes[type].v_max = velo
      }
    }
    if (spin > 0) {
      rawPitcherData[player].pitchtypes[type].s_count++
      rawPitcherData[player].pitchtypes[type].s_sum += spin
      if (seff > 0) {
        rawPitcherData[player].pitchtypes[type].seff_sum += seff
        rawPitcherData[player].pitchtypes[type].seff_c++
      }
      if (spin > rawPitcherData[player].pitchtypes[type].s_max) {
        rawPitcherData[player].pitchtypes[type].s_max = spin
      }
      if (vb !== 0 || hb !== 0) {
        rawPitcherData[player].pitchtypes[type].b_count++
        rawPitcherData[player].pitchtypes[type].h_break += hb
        rawPitcherData[player].pitchtypes[type].v_break += vb
      }
      if (sdir !== undefined) {
        rawPitcherData[player].pitchtypes[type].sdir_count++
        rawPitcherData[player].pitchtypes[type].sdir_h += sdir[0]
        rawPitcherData[player].pitchtypes[type].sdir_m += sdir[1]
      }
      if (gyro >= 0) {
        rawPitcherData[player].pitchtypes[type].gyro_count++
        rawPitcherData[player].pitchtypes[type].gyro_sum += gyro
      }
    }
    //collect global data
    if (globalSpeedAvg[type] === undefined) {
      let initPitchTypeData = {speedSum: 0, count: 0}
      globalSpeedAvg[type] = initPitchTypeData
    }
    if (velo > 0) {
      globalSpeedAvg[type].speedSum += velo
      globalSpeedAvg[type].count++
    }
    //wrap up personnal data
    //speed data
    if (pData.dataByPitcher[p.Player].speed[type] === undefined) {
      pData.dataByPitcher[p.Player].speed[type] = {sum: 0, velos: {}, count: 0}
    }
    if (velo > 0) {
      pData.dataByPitcher[p.Player].speed[type].sum += velo
      if (pData.dataByPitcher[p.Player].speed[type].velos[roundTo(velo)] === undefined) {
        pData.dataByPitcher[p.Player].speed[type].velos[roundTo(velo)] = 0
      }
      pData.dataByPitcher[p.Player].speed[type].velos[roundTo(velo)]++
      pData.dataByPitcher[p.Player].speed[type].count++
    }
    if (spin > 0) {
      //spin direction data
      if (pData.dataByPitcher[p.Player].sDirection[type] === undefined) {
        pData.dataByPitcher[p.Player].sDirection[type] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
      if (sdir !== undefined) {
        let idx = sdir[0]*2 + (sdir[1]>=30? 1:0)
        //console.log(sdir, idx)
        pData.dataByPitcher[p.Player].sDirection[type][idx]++
      }
      //movement data
      if (pData.dataByPitcher[p.Player].movement.coordinate[type] === undefined) {
        pData.dataByPitcher[p.Player].movement.coordinate[type] = []
      }
      pData.dataByPitcher[p.Player].movement.coordinate[type].push({x: hb, y: vb})
      pData.dataByPitcher[p.Player].movement.v.push({type: type, movement: vb})
      pData.dataByPitcher[p.Player].movement.h.push({type: type, movement: hb})
      //spin data
      pData.dataByPitcher[p.Player].spin.push({type: type, spin: spin})
      //release data
      if (pData.dataByPitcher[p.Player].release.coordinate[type] === undefined) {
        pData.dataByPitcher[p.Player].release.coordinate[type] = []
      }
      pData.dataByPitcher[p.Player].release.coordinate[type].push({x: rels, y: relh})
      pData.dataByPitcher[p.Player].release.trend.push({type: type, height: relh})
    }
  }

  for (const p of pData.playerList) {
    const pcount = pData.dataByPitcher[p].spin.length
    for (const t in pData.dataByPitcher[p].speed) {
      pData.dataByPitcher[p].speed[t].pcount = pcount
    }
  }

  //console.log('bprpdt:',rawPitcherData)
  
  pData.global = globalSpeedAvg
  pData.rawPitcherData = rawPitcherData

  //console.log('bppdata:', pData)

  return pData
}

const computeAverageDirection = (h, m, c) => {
  if (c === 0) return '-'
  else {
    let ah, am, total = Math.round((h*60 + m)/c);
    ah = Math.floor(total/60)
    am = total%60
    if (ah > 12) ah -= 12
    if (am < 10) am = `0${am}`
    return `${ah}:${am}`
  }
}

export const extractPlayByPlayData = (record, stat) => {
  let groupUpPitches = []
  let eachPitchData = {} // identify by cid
  for (const s of stat) {
    let id = concatClipId(s.Date, s.Clip_Id)
    let x = parseFloat(s.PlateLocSide), y = parseFloat(s.PlateLocHeight), velo = parseFloat(s['Velo-rel'])<=0? '-':parseFloat(s['Velo-rel'])
    let inZone = (s.Zone === 'IN'), ev = parseFloat(s.ExitSpeed), angle = parseFloat(s.Angle)
    eachPitchData[id] = { plateLoc: {x, y}, velo, inZone }
    if (y < -98) eachPitchData[id].plateLoc = undefined
    if (ev > 0) {
      eachPitchData[id].ev = ev
      eachPitchData[id].l_angle = angle
    }
  }
  for (const r of record) {
    let id = concatClipId(r.Date, r.Clip_Id)
    let balls = parseInt(r.Balls), strikes = parseInt(r.Strikes), outs = parseInt(r.Outs)
    if (balls === 1 && strikes === 1) { //start of a ab
      let init = {
        pitcher: r.Pitcher, pitcherSide: r.PT, batter: r.Batter, batterSide: r.rr, outs: outs,
        date: r.Date, fieldGraphData: {}, zoneGraphData: {}, pbp: [], playResult: {result: '-', ev: '-', la: '-'}
      }
      groupUpPitches.push(init)
    }
    if ((r.KorBB !== undefined && r.KorBB[0] !== undefined) || (r.PlayResult !== undefined && r.PlayResult[0] !== undefined)) {
      let result = (r.KorBB !== undefined && r.KorBB[0] !== undefined) ? r.KorBB : r.PlayResult
      groupUpPitches.at(-1).playResult = { result, ev: '-', la: '-' }
    }
    let pitchData = { tag: r.TaggedPitchType, speed: '-', call: r.PitchCall }
    if (eachPitchData[id] !== undefined && eachPitchData[id].velo !== undefined) pitchData.speed = eachPitchData[id].velo
    groupUpPitches.at(-1).pbp.push(pitchData)
    if (groupUpPitches.at(-1).zoneGraphData[r.TaggedPitchType] === undefined) groupUpPitches.at(-1).zoneGraphData[r.TaggedPitchType] = []
    if (eachPitchData[id] !== undefined && eachPitchData[id].plateLoc !== undefined) groupUpPitches.at(-1).zoneGraphData[r.TaggedPitchType].push(eachPitchData[id].plateLoc)
    if ((r.KorBB !== undefined && r.KorBB[0] !== undefined) || (r.PlayResult !== undefined && r.PlayResult[0] !== undefined)) { //play result meets
      let ev = eachPitchData[id] === undefined || eachPitchData[id].ev === undefined ? '-' : eachPitchData[id].ev
      let la = eachPitchData[id] === undefined || eachPitchData[id].l_angle === undefined ? '-' : eachPitchData[id].l_angle
      groupUpPitches.at(-1).playResult.ev = ev
      groupUpPitches.at(-1).playResult.la = la
    }
  }
  let PitcherPlayData = {}, BatterPlayData = {}, PitcherStat = {}, BatterStat = {} 
  const notAB = ['SF', 'SH', 'BB', 'HBP']
  const counted = ['1B', '2B', '3B', 'HR', 'E', 'BB', 'HBP', 'SF']
  for (const p of groupUpPitches) {
    let pitcher = p.pitcher, batter = p.batter
    if (PitcherPlayData[pitcher] === undefined) {
      PitcherPlayData[pitcher] = []
      PitcherStat[pitcher] = { PA: 0, AB: 0, '1B': 0, '2B': 0, '3B': 0, HR: 0, SO: 0, BB: 0, E: 0, HBP: 0, SF: 0 }
    }
    if (BatterPlayData[batter] === undefined) {
      BatterPlayData[batter] = []
      BatterStat[batter] = { PA: 0, AB: 0, '1B': 0, '2B': 0, '3B': 0, HR: 0, SO: 0, BB: 0, E: 0, HBP: 0, SF: 0 }
    }
    PitcherPlayData[pitcher].push(p)
    BatterPlayData[batter].push(p)
    PitcherStat[pitcher].PA++
    BatterStat[batter].PA++
    if (!notAB.includes(p.playResult.result)) {
      PitcherStat[pitcher]['AB']++
      BatterStat[batter]['AB']++
    }
    if (counted.includes(p.playResult.result)) {
      PitcherStat[pitcher][p.playResult.result]++
      BatterStat[batter][p.playResult.result]++
    }
    if (p.playResult.result === 'K') {
      PitcherStat[pitcher]['SO']++
      BatterStat[batter]['SO']++
    }
  }
  let PitcherStatArr = [], BatterStatArr = []
  for (const p in PitcherStat) {
    let ps = { ...PitcherStat[p] }
    let H = ps['1B'] + ps['2B'] + ps['3B'] + ps['HR']
    let TB = ps['1B'] + ps['2B']*2 + ps['3B']*3 + ps['HR']*4
    ps.AVG = ps.AB==='-'? 0:roundTo((H/ps.AB), 3)
    ps.OBP = roundTo(((H+ps.BB+ps.HBP)/(ps.AB+ps.BB+ps.HBP+ps.SF)), 3)
    ps.SLG = ps.AB===0? 0:roundTo((TB/ps.AB), 3)
    ps.OPS = roundTo(ps.OBP + ps.SLG, 3)
    ps['wOBA'] = ps.AB===0? 0:roundTo((((0.72*ps.BB)+(0.75*ps.HBP)+(0.9*ps['1B'])+(0.92*ps.E)+(1.24*ps['2B'])+(1.56*ps['3B'])+(1.95*ps.HR))/(ps.PA)), 3)
    ps.Player = p
    ps.H = H
    //PitcherStat[p] = ps
    PitcherStatArr.push(ps)    
  }
  for (const p in BatterStat) {
    let ps = { ...BatterStat[p] }
    let H = ps['1B'] + ps['2B'] + ps['3B'] + ps['HR']
    let TB = ps['1B'] + ps['2B']*2 + ps['3B']*3 + ps['HR']*4
    ps.AVG = ps.AB===0? '-':roundTo((H/ps.AB), 3)
    ps.OBP = roundTo(((H+ps.BB+ps.HBP)/(ps.AB+ps.BB+ps.HBP+ps.SF)), 3)
    ps.SLG = ps.AB===0? 0:roundTo((TB/ps.AB), 3)
    ps.OPS = roundTo(ps.OBP + ps.SLG, 3)
    ps['wOBA'] = ps.AB===0? 0:roundTo((((0.72*ps.BB)+(0.75*ps.HBP)+(0.9*ps['1B'])+(0.92*ps.E)+(1.24*ps['2B'])+(1.56*ps['3B'])+(1.95*ps.HR))/(ps.PA)), 3)
    //BatterStat[p] = ps
    ps.Player = p
    ps.H = H
    BatterStatArr.push(ps)
  }
  return {
    pStat: PitcherStatArr, bStat: BatterStatArr, pitcherPlays: PitcherPlayData, batterPlays: BatterPlayData
  }
}

export const extractAllPitcherData = (record, stat, bullpen) => {
    const st = extractDataByPitcher(record, stat)
    const bp = extractPitcherBullpenGraphData(bullpen)
    let PR_dataset = {AVGEV: [], MAXEV: [], FBAVGV: [], FBAVGS: [], CBAVGS: [], WHIFF: [], OSWING: [], STRIKEP: []}
    //merge global data
    const k1 = Object.keys(st.global), k2 = Object.keys(bp.global)
    let globalkeys = [...k1], globalData = {}
    for (const k of k2) if (!k1.includes(k)) globalkeys.push(k)
    for (const k of globalkeys) {
      let sum = 0, count = 0
      if (st.global[k] !== undefined) {
        sum += st.global[k].speedSum
        count += st.global[k].count
      }
      if (bp.global[k] !== undefined) {
        sum += bp.global[k].speedSum
        count += bp.global[k].count
      }
      globalData[k] = roundTo(sum/count, 1)
    }
    //console.log('st', st)
    //merge pitch data
    const p1 = st.pitcherList, p2 = bp.playerList
    let players = [...p1], playerTableData = {}, playerGraphData = {}
    for (const p of p2) if (!p1.includes(p)) players.push(p)
    //console.log(players)
    for (const p of players) {
      let mergedPitchTypeData = st.dataByPitcher[p]===undefined? {}:JSON.parse(JSON.stringify(st.dataByPitcher[p].pitchTypes))
      if (st.dataByPitcher[p] !== undefined) {
        playerTableData[p] = {}
        playerTableData[p].overall = st.dataByPitcher[p].overall
      }
      if (bp.rawPitcherData[p] !== undefined) {
        for (const t in bp.rawPitcherData[p].pitchtypes) {
          if (mergedPitchTypeData[t] !== undefined) {
            for (const k in mergedPitchTypeData[t]) {
              if (k === 'velos') continue
              if (k === 'v_max' || k === 's_max') {
                if (mergedPitchTypeData[t][k] < bp.rawPitcherData[p].pitchtypes[t][k]) {
                  mergedPitchTypeData[t][k] = bp.rawPitcherData[p].pitchtypes[t][k] 
                }
                continue
              }
              mergedPitchTypeData[t][k] += bp.rawPitcherData[p].pitchtypes[t][k]
            }
          } else {
            mergedPitchTypeData[t] = bp.rawPitcherData[p].pitchtypes[t]
          }
        }
      }
      let pts = [];
      for (const pt in mergedPitchTypeData) {
        let ptd = [], rptd = mergedPitchTypeData[pt]
        ptd.push(pt) //pitchtype
        let va, sa, vb, hb, se, gd, sd, sp
        va = rptd.v_count===0? '-':Math.round(rptd.v_sum*10/rptd.v_count)/10
        sa = rptd.s_count===0? '-':Math.round(rptd.s_sum*10/rptd.s_count)/10
        vb = rptd.b_count===0? '-':Math.round(rptd.v_break*10/rptd.b_count)/10
        hb = rptd.b_count===0? '-':Math.round(rptd.h_break*10/rptd.b_count)/10
        se = rptd.seff_c===0? '-':Math.round(rptd.seff_sum*10/rptd.seff_c)/10
        gd = rptd.gyro_count===0? '-':Math.round(rptd.gyro_sum*10/rptd.gyro_count)/10
        sd = computeAverageDirection(rptd.sdir_h, rptd.sdir_m, rptd.sdir_count)
        sp = rptd.count===0? '-':Math.round(rptd.strike*10*100/rptd.count)/10
        ptd.push(va); ptd.push(rptd.v_max===0? '-':rptd.v_max); ptd.push(sa); ptd.push(rptd.s_max===0? '-':rptd.s_max)
        ptd.push(vb); ptd.push(hb); ptd.push(se); ptd.push(gd); ptd.push(sd); ptd.push(sp)
        pts.push(ptd)
      }
      playerTableData[p].pitchTypes = pts
      //pack speed data
      let bpcount = (bp.dataByPitcher[p]===undefined||bp.dataByPitcher[p].speed === {})? 0:bp.dataByPitcher[p].speed[Object.keys(bp.dataByPitcher[p].speed)[0]].pcount
      let sumPitchSpeedInfo = {}, total = st.dataByPitcher[p].pitchescount + bpcount
      for (const pt in mergedPitchTypeData) {
        sumPitchSpeedInfo[pt] = {}
        let sum = 0, count = 0, velos = {}
        if (st.dataByPitcher[p] !== undefined && st.dataByPitcher[p].pitchTypes[pt] !== undefined) {
          //console.log(st.dataByPitcher[p].pitchTypes[pt])
          sum += st.dataByPitcher[p].pitchTypes[pt].v_sum
          count += st.dataByPitcher[p].pitchTypes[pt].v_count
          //total += st.dataByPitcher[p].pitchescount
          for (const v in st.dataByPitcher[p].pitchTypes[pt].velos) {
            if (velos[v] === undefined) {
              velos[v] = 0
            }
            velos[v] += st.dataByPitcher[p].pitchTypes[pt].velos[v]
          }
        }
        if (bp.dataByPitcher[p] !== undefined && bp.dataByPitcher[p].speed[pt] !== undefined) {
          //console.log(bp.dataByPitcher[p].speed[pt])
          sum += bp.dataByPitcher[p].speed[pt].sum
          count += bp.dataByPitcher[p].speed[pt].count
          //total += bp.dataByPitcher[p].speed[pt].pcount
          for (const v in bp.dataByPitcher[p].speed[pt].velos) {
            if (velos[v] === undefined) {
              velos[v] = 0
            }
            velos[v] += bp.dataByPitcher[p].speed[pt].velos[v]
          }
        }
        sumPitchSpeedInfo[pt].avg = roundTo(sum/count, 1)
        sumPitchSpeedInfo[pt].usage = Math.round(count*100/total)
        for (const v in velos) velos[v] = Math.round(velos[v]*100/total)
        //console.log(p, velos)
        sumPitchSpeedInfo[pt].velos = velos
        //console.log(count, total)
      }
      //console.log(p, sumPitchSpeedInfo)
      playerGraphData[p] = {}
      playerGraphData[p].speed = sumPitchSpeedInfo
      playerGraphData[p].spin = bp.dataByPitcher[p]===undefined? []:bp.dataByPitcher[p].spin
      playerGraphData[p].release = bp.dataByPitcher[p]===undefined? {coordinate: {}, trend: []}:bp.dataByPitcher[p].release
      playerGraphData[p].movement = bp.dataByPitcher[p]===undefined? {coordinate: {}, h: [], v: []}:bp.dataByPitcher[p].movement
      playerGraphData[p].sDirection = bp.dataByPitcher[p]===undefined? {}:bp.dataByPitcher[p].sDirection
    }
    //console.log('ptd:', playerTableData)
    //console.log('pgd:', playerGraphData)
    const playData = extractPlayByPlayData(record, stat)

    //collect PR data
    let StatByPlayer = {}
    for (const p of players) {
      StatByPlayer[p] = {AVGEV: undefined, MAXEV: undefined, FBAVGV: undefined, FBAVGS: undefined, CBAVGS: undefined, WHIFF: undefined, OSWING: undefined, STRIKEP: undefined}
      if (playerTableData[p].overall[0][11] !== '-') {
        StatByPlayer[p].AVGEV = playerTableData[p].overall[0][11]
        PR_dataset.AVGEV.push(playerTableData[p].overall[0][11])
      }
      if (playerTableData[p].overall[0][12] !== '-') {
        StatByPlayer[p].MAXEV = playerTableData[p].overall[0][12]
        PR_dataset.MAXEV.push(playerTableData[p].overall[0][12])
      }
      if (playerTableData[p].overall[0][14] !== '-') {
        StatByPlayer[p].WHIFF = playerTableData[p].overall[0][14]
        PR_dataset.WHIFF.push(playerTableData[p].overall[0][14])
      }
      if (playerTableData[p].overall[1][2] !== '-') {
        StatByPlayer[p].OSWING = playerTableData[p].overall[1][2]
        PR_dataset.OSWING.push(playerTableData[p].overall[1][2])
      }
      for (const t of playerTableData[p].pitchTypes) {
        if (t[0] === 'FB') {
          if (!isNaN(t[1])) {
            StatByPlayer[p].FBAVGV = t[1]
            PR_dataset.FBAVGV.push(t[1])
          }
          if (!isNaN(t[3])) {
            StatByPlayer[p].FBAVGS = t[3]
            PR_dataset.FBAVGS.push(t[3])
          }
        }
        if (t[0] === 'CB') {
          if (!isNaN(t[3])) {
            StatByPlayer[p].CBAVGS = t[3]
            PR_dataset.CBAVGS.push(t[3])
          }
        }
      }
      if (st.dataByPitcher[p].cumStrikeP !== undefined) {
        StatByPlayer[p].STRIKEP = st.dataByPitcher[p].cumStrikeP
        PR_dataset.STRIKEP.push(st.dataByPitcher[p].cumStrikeP)
      }
    }

    for (const i in PR_dataset) {
      if (['AVGEV', 'MAXEV'].includes(i)) PR_dataset[i].sort((a,b)=>(b-a))
      else PR_dataset[i].sort((a,b)=>(a-b))
    }
    //console.log('PR', PR_dataset)
    for (const i in StatByPlayer) {
      for (const k in StatByPlayer[i]) {
        if (StatByPlayer[i][k] !== undefined) {
          const pr = bSearchPRCalc(PR_dataset[k], StatByPlayer[i][k], ['AVGEV', 'MAXEV'].includes(k))
          StatByPlayer[i][k] = pr
        }
      }
    }
    //console.log('PRRRRR', StatByPlayer)

    return { 
      playerList: players, table: playerTableData, graph: playerGraphData, global: globalData,
      pbpData: playData.pitcherPlays, prGraph: StatByPlayer
    }
}

export const extractPitcherVelocityData = (data) => {
  //console.log(data)
  let pData = {vMax: [], vAvg: []}
  for (const p in data) {
    let vMax = {Player: p, '4-Seamer': '-', Changeup: '-', Curve: "-", Cutter: "-", Knuckle: "-", Sinker: "-", Slider: '-', Splitter: "-", Unknown: "-"}
    let vAvg = {Player: p, '4-Seamer': '-', Changeup: '-', Curve: "-", Cutter: "-", Knuckle: "-", Sinker: "-", Slider: '-', Splitter: "-", Unknown: "-"}
    for (const i of data[p].pitchTypes) {
      if (pitchTypeTagMap[i[0]] !== undefined) {
        vAvg[pitchTypeTagMap[i[0]]] = i[1]
        vMax[pitchTypeTagMap[i[0]]] = i[2]
      }
    }
    pData.vAvg.push(vAvg)
    pData.vMax.push(vMax)
  }
  return pData
}

export const extractPlateLocationData = (plays) => {
  let data = {}
  for (const p of plays) {
    for (const l in p.zoneGraphData) {
      if (data[l] === undefined) {
        data[l] = []
      }
      for (const d of p.zoneGraphData[l]) {
        data[l].push(d)
      }
    }
  }
  return data
}